import {marked} from "marked";


marked.use({ extensions: [] });


export default marked;
